const IOS_OS = 'iOS';
const isWebviewIOS = device => {
  var _device$nativeApp;
  return (device === null || device === void 0 || (_device$nativeApp = device.nativeApp) === null || _device$nativeApp === void 0 ? void 0 : _device$nativeApp.os) === IOS_OS;
};
export { isWebviewIOS as default };
